import { Component, OnDestroy, Input, ViewChild, ElementRef, HostListener } from '@angular/core';
import { BroadcastService } from 'src/app/services/broadcast.service';
import { Subscription } from 'rxjs';
import { Filter } from 'src/app/models/filter';
import { ResizeService } from 'src/app/services/resize.service';
import { LocaleService } from '../../services/locale.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnDestroy {
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (this.isSidebarOpen && event.key === 'Escape') {
      this.toggleSidebar(false);
    }
  }

  @Input()
  filters: Filter[];

  @ViewChild('aside', { read: ElementRef, static: false })
  asideEl: ElementRef;

  isSidebarOpen = false;
  sidebarSub: Subscription;
  searchModelSub: Subscription;
  textDirection: string;
  defaultIconHide = 'expand_double_right';
  hideButtonsSideMenu = false;

  constructor(
    private broadcastService: BroadcastService,
    private resizeService: ResizeService,
    private localService: LocaleService
  ) {
    this.sidebarSub = broadcastService.sidebar$.subscribe((open) => {
      this.isSidebarOpen = open;
    });
    this.searchModelSub = broadcastService.searchModel$.subscribe((model) => {
      this.hideButtonsSideMenu = model.hideButtonsSideMenu;
    });

    this.textDirection = this.localService.getTextDirection();

    if (this.textDirection === 'rtl') {
      this.defaultIconHide = 'expand_double_left';
    }
  }

  ngOnDestroy() {
    this.sidebarSub.unsubscribe();
    this.searchModelSub.unsubscribe();
  }

  toggleSidebar(force?: boolean) {
    this.isSidebarOpen = force ? force : !this.isSidebarOpen;
    this.broadcastService.broadcastSidebar(this.isSidebarOpen);
  }

  onAction() {
    if (this.resizeService.isMobile) {
      this.toggleSidebar();
    }
  }
}
